export default class ReportReasonModal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);

    if (!this.modal) return;

    this.submitButton = this.modal.querySelector('.js-report-modal-submit');
    this.cancelButton = this.modal.querySelector('.js-report-modal-cancel');
    this.reportReasonInputs = this.modal.querySelectorAll(
      'input[name="report_reason"]'
    );

    this.init();
  }

  init() {
    this.updateSubmitButton();
    this.addEventListeners();
  }

  updateSubmitButton() {
    const isAnyRadioSelected = Array.from(this.reportReasonInputs).some(
      (radio) => radio.checked
    );

    this.submitButton.disabled =
      this.reportReasonInputs.length > 0 ? !isAnyRadioSelected : false;
  }

  addEventListeners() {
    this.reportReasonInputs.forEach((radio) => {
      radio.addEventListener('change', () => this.updateSubmitButton());
    });

    this.cancelButton.addEventListener('click', (event) => {
      event.preventDefault();
      $.modal.close();
    });

    this.submitButton.addEventListener('click', () => this.handleSubmit());
  }

  handleSubmit() {
    if (this.submitButton.disabled) return;

    const selectedReason = this.modal.querySelector(
      'input[name="report_reason"]:checked'
    );
    const detail = this.modal.querySelector('textarea')?.value || '';
    const data = {
      report: {
        reportable_type: this.modal.dataset.reportableType,
        reportable_id: this.modal.dataset.reportableId,
        report_reason_id: selectedReason?.value || '',
        detail: detail,
      },
    };

    fetch('/reports', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          .content,
        Accept: 'text/javascript',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Network response was not ok.');
      })
      .then((script) => {
        Function(`"use strict";return (${script})`)();
        $.modal.close();
      })
      .catch((error) => {
        console.error('Error:', error);
        $.modal.close();
      });
  }
}
